import { createImageUrlBuilder, SanityImageSource } from '@sanity/image-url';
import { getGlobalConfig } from '@dealstack/frontend/shared/globalConfig.ts';
import { ApplicationType } from '@dealstack/shared/lib/generated';

const config = getGlobalConfig();

const builder = (dataset: string) =>
	createImageUrlBuilder({
		projectId: config.sanityProjectId || 'temp',
		dataset,
	});

export const sanityAppMediaUrl = (source: SanityImageSource) =>
	builder(ApplicationType.DEALSTACK).image(source);
export const sanityInvestorMediaUrl = (source: SanityImageSource) =>
	builder(ApplicationType.INVESTOR).image(source);
